(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["royal-analysis"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-royal-analysis]').forEach((section) => {
    const checks = section.querySelectorAll('input[type="checkbox"]');
    const link = section.querySelector('[data-scan-link]');
    const baseUrl = link.getAttribute('href');
    const update = () => {
      const goals = Array.from(checks).filter((input) => input.checked).map((input) => input.value);
      const active = goals.length > 0;
      link.setAttribute('aria-disabled', active ? 'false' : 'true');
      link.href = active ? `${baseUrl}${baseUrl.includes('?') ? '&' : '?'}goals=${encodeURIComponent(goals.join(','))}` : baseUrl;
    };
    checks.forEach((input) => input.addEventListener('change', update));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["royal-reup"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-reup-routine]').forEach((button) => {
    button.addEventListener('click', async () => {
      const message = button.parentElement.querySelector('[data-reup-message]');
      const original = button.textContent;
      button.disabled = true;
      message.textContent = '';
      try {
        const response = await fetch(button.dataset.cartAddUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: JSON.parse(button.dataset.items) })
        });
        if (!response.ok) throw new Error('cart');
        window.location.assign(button.dataset.cartUrl);
      } catch (error) {
        message.textContent = button.dataset.errorMessage;
        button.disabled = false;
        button.textContent = original;
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
